import React from "react";
import Header from "../../header";

import { ServiceHistoryTabs } from "./ServiceHistoryTabs";

const ServiceHistory = () => {
  return (
    <>
      <Header showSearchBar={true} title={"خدمات من"} />

      <div className="serviceHistoryWrapper">
        <ServiceHistoryTabs />
      </div>
    </>
  );
};

export default ServiceHistory;
